<template>
  <div
    
    class="contactInformation p-6 text-left"
  >
    <div class="py-3 text-center"> 
      <p class="text-md font-medium py-2">
        UPDATE YOUR TICKET PACKAGE
      </p>

      <a href="/settings/update-tickets">
        <button
          class="mx-auto rounded-lg my-4 py-2 px-4 bg-gray-500 text-gray-100 hover:bg-gray-800 duration-300 text-base"
        >
          SELECT NEW TICKETS
        </button>
      </a>
    </div>
  </div>
</template>

<script>
    export default {
        name: "UpdateTicketPackagesLinkCard"
    }
</script>

<style lang="scss" scoped>

</style>